angular.module('admin')
.directive('dictNav',function(){
	return function(scope,element,attrs) {
		var self = {};
		var KEYUP = 38; 
		var KEYDOWN = 40; 
		var KEYTAB = 9;
		self.selectedItem = null;
		element.bind("keydown", function(event) {
			options = element.find('ul li');
			if(event.which === 13 || event.which === KEYTAB) {
				if (options.length > 0) {
					if (!self.selectedItem) self.selectedItem = 0;
				}
				if (self.selectedItem !== null) {
					options.eq(self.selectedItem).find('[ng-click]').click();
				}
				event.preventDefault();
			} else if (event.which === KEYUP) {
				if (self.selectedItem === null) {
					self.selectedItem = self.options.length - 1;
				} else {
					self.selectedItem -= 1;
					if (self.selectedItem == -1) self.selectedItem = options.length - 1;
				}
				//console.log(options, self.selectedItem);
				options.eq(self.selectedItem).addClass('active').siblings().removeClass('active');
				options.eq(self.selectedItem)[0].scrollIntoView();
			} else if (event.which === KEYDOWN) {
				if (self.selectedItem === null) {
					self.selectedItem = 0;
				} else {
					self.selectedItem += 1;
					if (self.selectedItem >= options.length) self.selectedItem = 0;
				}
				options.eq(self.selectedItem).addClass('active').siblings().removeClass('active');
				options.eq(self.selectedItem)[0].scrollIntoView();
			} else {
				self.selectedItem = null;
				options.removeClass('active');
			}
			console.log(self.selectedItem);
		});
	}
});